'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { SegmentedControl } from '@/components/ui/segmented-control';
interface SuggestedOutcomesHeaderProps {
  sort: 'top' | 'recent';
  onSortChange: (sort: 'top' | 'recent') => void;
}

/**
 * Header for the Suggested-outcomes panel. Keeps the title and sort control
 * aligned with the Backers panel, then explains the lifecycle boundary before
 * the user enters the suggestion flow.
 */
export function SuggestedOutcomesHeader(t0) {
  const $ = _c(31);
  const {
    sort,
    onSortChange
  } = t0;
  const t = useTranslations("launchpad.suggestedOutcomes");
  let t1;
  if ($[0] !== t) {
    t1 = t("title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-body-lg font-medium text-foreground-primary">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("sortTop");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      key: "top",
      label: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("sortRecent");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      key: "recent",
      label: t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = [t4, t6];
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onSortChange) {
    t8 = key => onSortChange(key === "recent" ? "recent" : "top");
    $[15] = onSortChange;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== sort || $[18] !== t7 || $[19] !== t8) {
    t9 = <SegmentedControl items={t7} active={sort} onChange={t8} layoutId="suggested-outcomes-toggle" variant="chart-filled" asTabs={true} />;
    $[17] = sort;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t2 || $[22] !== t9) {
    t10 = <div className="flex items-center justify-between gap-2">{t2}{t9}</div>;
    $[21] = t2;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("timingHelp");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = <p className="text-caption text-foreground-tertiary">{t11}</p>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12) {
    t13 = <header className="flex flex-col gap-2">{t10}{t12}</header>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}